import Agent from "./agent";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import Station from "./station";
import { useContext, useEffect } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";

const Management = () => {
  const { pathname } = useLocation();
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  useEffect(() => {}, []);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <div>
        <h1 className=" text-2xl leading-9">Stations and Agents</h1>
      </div>
      <div>
        <div className=" flex items-center justify-start gap-6 my-5 whitespace-nowrap  w-full border-b-[0.2px] border-[#A6A6A6]">
          <Link
            to="/management/station"
            className={` py-1 md:py-3 text-[#848484] text-sm border-b-4 hover:border-b-4 hover:border-[#FF6A3A] ${
              pathname.includes("/management/station")
                ? "  text-[#FF6A3A]  border-b-4 border-[#FF6A3A] "
                : "border-[#FFFDFB] "
            }`}
          >
            Station Management
          </Link>
          <Link
            to="/management/agent"
            className={` py-1 text-[#848484] text-sm md:py-3 border-b-4 hover:border-b-4 hover:border-[#FF6A3A] ${
              pathname.includes("/management/agent")
                ? "  text-[#FF6A3A] border-b-4 border-[#FF6A3A] "
                : "border-[#FFFDFB] "
            }`}
          >
            Agents Management
          </Link>
        </div>
      </div>

      <Routes>
        <Route path="/" element={<Station />} />
        <Route path="agent" element={<Agent />} />
        <Route path="station" element={<Station />} />
      </Routes>
    </div>
  );
};

export default Management;
